export const createQueue = ({ maxQueue = 1 } = {}) => {
  return {
    items: [],
    numOfActive: 0,
    callback: () => null,
    add(item) {
      this.items.push(item);
      return this;
    },
    incrase() {
      if (this.numOfActive < maxQueue) {
        this.numOfActive += 1;
      }
    },
    decrase() {
      if (this.numOfActive > 0) {
        this.numOfActive -= 1;
      }
    },
    isActive() {
      return this.numOfActive > 0;
    },
    done() {
      this.decrase();
      return this;
    },
    cancel(value) {
      this.items = this.items.filter(({ code }) => code !== value);
      return this;
    },
    next() {
      const max = maxQueue - this.numOfActive;

      if (max > 0) {
        let maxItems = this.items.slice(0);

        maxItems.splice(max);

        this.items.splice(0, max);

        maxItems.forEach(({ code, callback }) => {
          this.incrase();
          if (typeof callback === "function") {
            callback(code);
          }
        });
      }

      return this;
    },
  };
};
